import React from "react";

// Custom Hooks
import {
  UPDATE_TITLE,
  UPDATE_DUE_DATE,
  UPDATE_REMINDERS,
  UPDATE_RECURRING_REQUEST,
  UPDATE_EMAIL_DESCRIPTION,
} from "../hooks/useRequestMutationForm";

// Custom Components
import RequestDropdown, {
  CLEAR_SELECTION_TEXT,
} from "../../../Dropdown/RequestDropdown";
import { format, isBefore } from "date-fns";

function RequestForm({ onChange, state = {} }) {
  const handleDueDateChange = (e) => {
    const selectedDate = e.target.value;
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone; // Detect user's time zone

    // Convert selected date to user's time zone
    const selectedDateInTimeZone = new Date(selectedDate + "T00:00:00");
    const selectedDateInUserTimeZone = format(
      selectedDateInTimeZone,
      "yyyy-MM-dd'T'HH:mm:ssxxx",
      { timeZone: userTimeZone }
    );

    // Get current date in user's time zone
    const currentDate = new Date();
    const currentDateInUserTimeZone = format(
      currentDate,
      "yyyy-MM-dd'T'HH:mm:ssxxx",
      { timeZone: userTimeZone }
    );

    // Check if the selected date is before the current date
    if (
      isBefore(
        new Date(selectedDateInUserTimeZone),
        new Date(currentDateInUserTimeZone)
      )
    ) {
      // If it's before the current date, set it to the current date
      onChange(UPDATE_DUE_DATE, format(new Date(), "yyyy-MM-dd"));
    } else {
      // Otherwise, update the state with the selected date
      onChange(UPDATE_DUE_DATE, format(selectedDateInTimeZone, "yyyy-MM-dd"));
    }
  };
  return (
    <section className="request-mutation-modal-body-first-section">
      <div className="my-5">
        <label htmlFor="requestTitle">{"Request Title *"}</label>
        <input
          type="text"
          placeholder="Enter Request Name"
          maxLength="50"
          id="requestTitle"
          className="request-mutation-modal-body-input"
          value={state.title}
          onChange={(e) => onChange(UPDATE_TITLE, e.target.value)}
        />
      </div>
      <div className="mb-5">
        <label>{"Due Date *"}</label>
        <input
          className="form-control min-height-49"
          name="dueDate"
          type="date"
          value={state.dueDate}
          min={format(new Date(), "yyyy-MM-dd")}
          onChange={handleDueDateChange}
        />
      </div>
      <div className="mb-5">
        <label>{"Reminders"}</label>
        <RequestDropdown
          value={state.reminders}
          onChange={(value) => {
            onChange(UPDATE_REMINDERS, value);
          }}
          options={[
            "Daily",
            "Every other Day",
            "Weekly",
            "Bi-weekly",
            "Monthly",
          ]}
        />
      </div>
      <div className="mb-5">
        <label>{"Recurring Request"}</label>
        <RequestDropdown
          value={state.recurringRequest}
          options={["Quarterly", "Monthly", "Annually", CLEAR_SELECTION_TEXT]}
          onChange={(value) => {
            if (value === CLEAR_SELECTION_TEXT) {
              onChange(UPDATE_RECURRING_REQUEST, "");
              return;
            }
            onChange(UPDATE_RECURRING_REQUEST, value);
          }}
          // ! Note:- Need to review after 12th April 2024 milestone
          disabled={true}
        />
      </div>
      <div className="pb-5">
        <label>Request Description</label>
        <textarea
          placeholder="Enter Request Description"
          maxLength="300"
          rows={10}
          style={{ minHeight: "247px" }}
          onChange={(e) => {
            onChange(UPDATE_EMAIL_DESCRIPTION, e.target.value);
          }}
          value={state.emailDescription}
        />
      </div>
    </section>
  );
}

export default RequestForm;
